import React, { useState } from 'react';
import { Flex, Typography } from 'antd';
import { getIcon, ICONS } from '../../icons';
import { COLOURS } from '../../colours';
import './Timeline.css';
import useMobileCheck from '../../mobile';

const { Title, Paragraph } = Typography;

const Timeline = ({
  title,
  timeline
}) => {

  const [ selected, setSelected] = useState(0);
  const { isMobile } = useMobileCheck();

  return (
    <Flex
      style={{ 
        borderRadius: '16px',
        background: 'white',
        width: '100%'
      }}
      vertical
      >
      <Flex justify={ isMobile ? 'flex-start' : 'center' } style={{ 
        width: '100%', 
        marginBottom: '20px'
      }}>
        <Title>{title}</Title>
      </Flex>
      <Flex
        vertical
        style={{ 
          padding: isMobile ? '10px' : '64px'
        }}
        >
        { timeline.map ( (t, index) => { 
          return <Flex
            gap={20}
            style={{ 
              display: 'grid',
              gridTemplateColumns: isMobile ? '100px 1fr' : '1fr 100px 1fr'
            }}
            onMouseOver={() => { 
              setSelected(index);
            }}
            >
            { !isMobile && <Title level={5} style={{ marginTop: "0px" }}>{t.title}</Title> }
            <div className="container">
              <div className={ `vertical-line ${index === selected ? 'selected' : ''}` }></div>
              <div className="circles-container">
                  <div className={`circle circle-1 ${index === selected ? 'selected' : ''}`}></div>
                  <div className={`circle circle-2 ${index === selected ? 'selected' : ''}`}></div>
                  <div className={`circle circle-3 ${index === selected ? 'selected' : ''}`}>
                      <span>0{ index + 1 }</span>
                  </div>
              </div>
            </div>
            <Flex vertical>
              { isMobile && <Title level={5} style={{ marginTop: "0px" }}>{t.title}</Title> }
              <Paragraph
                style={{ marginBottom: '64px' }}
                  >{t.description}</Paragraph>
            </Flex>
          </Flex>
        } ) }
      </Flex>
    </Flex>
  );
};

export default Timeline;
